import Vue from 'vue'
const worker = new Worker('./search.worker.js', { type: 'module' })

export const results = Vue.observable({ matches: [], restrictedMatches: [] })

let requestCounter = 0
let responseCounter = 0

worker.onmessage = event => {
  let { uuid, matches, restrictedMatches } = event.data

  if (uuid > responseCounter) {
    responseCounter = uuid
    results.matches = matches
    results.restrictedMatches = restrictedMatches
  }
}

export function search(width, length, height) {
  requestCounter++

  if (typeof width !== 'number' || typeof length !== 'number') {
    responseCounter = requestCounter
    results.matches = []
    results.restrictedMatches = []
    return
  }

  worker.postMessage({ uuid: requestCounter, width, length, height })
}
